var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"closeIcon":true,"size":"md","withoutFooter":true},on:{"close":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('PriceTable')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }